var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 18,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon__x2F__SearchCircular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "currentColor",
    d: "M15.12,8.74c-.31-2.84-2.57-5.1-5.41-5.41v-1.4h-1.36v1.4c-2.84.31-5.1,2.57-5.41,5.41h-1.4v1.36h1.4c.31,2.84,2.57,5.1,5.41,5.41v1.4h1.36v-1.4c2.84-.31,5.1-2.57,5.41-5.41h1.4v-1.36h-1.4ZM9.03,14.19c-2.64,0-4.77-2.13-4.77-4.77s2.13-4.77,4.77-4.77,4.77,2.13,4.77,4.77-2.13,4.77-4.77,4.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCircular);
export default __webpack_public_path__ + "static/media/searchCircular.37ce6a67a262a3be0c95821245bb710f.svg";
export { ForwardRef as ReactComponent };